"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniquePatterns = void 0;
const getPatternHash_1 = require("./getPatternHash");
const getUniquePatterns = (patterns) => {
    const hashes = new Set();
    const uniquePatterns = [];
    for (const pattern of patterns) {
        const hash = (0, getPatternHash_1.getPatternHash)(pattern);
        if (!hashes.has(hash)) {
            hashes.add(hash);
            uniquePatterns.push(pattern);
        }
    }
    return uniquePatterns;
};
exports.getUniquePatterns = getUniquePatterns;
